import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get Garden List
export const getComunalGardenlist = createAsyncThunk(
  "getComunalGardenlist",
  async (
    { search, pageLimit, pageCount, sort_by, sort_direction },
    { rejectWithValue }
  ) => {
    try {
      let queryParams = [];

      if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
      if (pageCount) queryParams.push(`page=${pageCount}`);
      if (pageLimit) queryParams.push(`limit=${pageLimit}`);
      if (sort_by) queryParams.push(`sortBy=${sort_by}`);
      if (sort_direction) queryParams.push(`sortOrder=${sort_direction}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await AxiosApi.get(
        `/communal-garden/get-communal-garden${queryString}`
      );
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Something went wrong"
      );
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

// Create garden
export const createCommunalGarden = createAsyncThunk(
  "createCommunalGarden",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(
        `/communal-garden/add-communal-garden`,
        data
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Edit garden
export const editCommunalGarden = createAsyncThunk(
  "editCommunalGarden",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(
        `/communal-garden/update-communal-garden`,
        data
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete Meditation
export const deleteCommunalGarden = createAsyncThunk(
  "deleteCommunalGarden",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(
        `/communal-garden/delete-communal-garden/${id}`
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const communalGardenSlice = createSlice({
  name: "communalGarden",
  initialState: initialStates,

  extraReducers: (builder) => {
    builder
      // get garden list
      .addCase(getComunalGardenlist.pending, (state) => {
        state.loading = true;
      })
      .addCase(getComunalGardenlist.fulfilled, (state, action) => {
        state.loading = false;
        state.getComunalGardenlistStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getComunalGardenlist.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //create meditation
      .addCase(createCommunalGarden.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCommunalGarden.fulfilled, (state, action) => {
        state.loading = false;
        state.createCommunalGardenStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createCommunalGarden.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //create communal garden
      .addCase(editCommunalGarden.pending, (state) => {
        state.loading = true;
      })
      .addCase(editCommunalGarden.fulfilled, (state, action) => {
        state.loading = false;
        state.editCommunalGardenStatus.data = action.payload;
        state.error = false;
      })
      .addCase(editCommunalGarden.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })

      // Delete Meditation
      .addCase(deleteCommunalGarden.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCommunalGarden.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteCommunalGardenStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteCommunalGarden.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setCommunalGarden } = communalGardenSlice.actions;
export default communalGardenSlice.reducer;
